import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { socket } from "../../socket";
import { acquireSocketConnection, releaseSocketConnection } from "../../socketLifecycle";

const OWNER = "unified-inbox";

export default function useInboxSocket(businessId, activeConversationId) {
  const qc = useQueryClient();

  useEffect(() => {
    if (!businessId) return;
    const joinBiz = () => socket.emit("inbox:join_business", { business_id: businessId });
    acquireSocketConnection(OWNER);
    if (socket.connected) joinBiz();
    else socket.on("connect", joinBiz);
    return () => {
      socket.off("connect", joinBiz);
      releaseSocketConnection(OWNER);
    };
  }, [businessId]);

  useEffect(() => {
    if (!activeConversationId) return;
    const joinConv = () =>
      socket.emit("inbox:join_conversation", { conversation_id: activeConversationId });
    if (socket.connected) joinConv();
    else socket.on("connect", joinConv);
    return () => {
      socket.off("connect", joinConv);
      if (socket.connected)
        socket.emit("inbox:leave_conversation", { conversation_id: activeConversationId });
    };
  }, [activeConversationId]);

  useEffect(() => {
    function onNewMessage(payload) {
      qc.invalidateQueries({ queryKey: ["inbox-conversations"] });
      const conv = payload?.conversation;
      if (conv && conv.id === activeConversationId) {
        qc.invalidateQueries({ queryKey: ["inbox-messages", activeConversationId] });
      }
    }
    function onConvUpdate() {
      qc.invalidateQueries({ queryKey: ["inbox-conversations"] });
      if (activeConversationId)
        qc.invalidateQueries({ queryKey: ["inbox-conversation", activeConversationId] });
    }

    socket.on("inbox:new_message", onNewMessage);
    socket.on("inbox:conversation_update", onConvUpdate);
    socket.on("inbox:message_status", onNewMessage);
    return () => {
      socket.off("inbox:new_message", onNewMessage);
      socket.off("inbox:conversation_update", onConvUpdate);
      socket.off("inbox:message_status", onNewMessage);
    };
  }, [activeConversationId, qc]);

  return { socket };
}
